export const useStyles = (theme) => ({
  paper: {
    padding: 20,
  },
  body: {
    minHeight: "20vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
});
